import { render } from "./SendersView.vue?vue&type=template&id=5125e866&scoped=true&ts=true"
import script from "./SendersView.vue?vue&type=script&lang=ts"
export * from "./SendersView.vue?vue&type=script&lang=ts"

import "./SendersView.vue?vue&type=style&index=0&id=5125e866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5125e866"]])

export default __exports__